import store from "../store";
import axios from 'axios';
import router from "../router";
import urls from '../urls/config';

import HelperFunctions from "@/classes/HelperFunctions";

export default {
    setCandidateToken(token) {
        localStorage.setItem('candidate_token', 'Bearer ' + token);
    },
    setAccessToken(token) {
        localStorage.setItem('access_token', token);
    },
    getAccessToken() {
        return localStorage.getItem('access_token');
    },
    getCandidateToken() {
        return localStorage.getItem('candidate_token');
    },

    setCandidateAxiosHeader() {
        axios.defaults.headers.common['Authorization'] = this.getCandidateToken();
    },

    async storeCandidate(data) {

        await store.dispatch('candidate/setCandidate', data.candidate);

        await store.dispatch('candidate/setActiveTesting', data.testing);

        if (!data.testing) {
            if (data.events) {
                await store.dispatch('candidate/setTestingEvents', data.events);

                for (let te of data.events) {
                    if (!te.candidateEvent && !te.isLate && !te.isPassed) {
                        await store.dispatch('candidate/setCurrentEvent', te);
                        break;
                    }
                }

            }
        } else {
            await store.dispatch('candidate/setActiveEvent', data.activeEvent);
            await store.dispatch('candidate/setCurrentTesting', data.candidateTest);
            await store.dispatch('candidate/setCurrentEvent', data.event);
        }
    },

    storeAnswer(form) {
        let answers = store.getters['candidate/getAnswers'];
        let items = [];
        for (let item of answers) {
            if (parseInt(item.questionId) !== parseInt(form.questionId)) {
                items.push(item);
            }
        }
        items.push(form);
        store.dispatch('candidate/setAnswereds', items);
    },


    loadCandidate(isTesting = false) {

        this.setCandidateAxiosHeader();


        if (!store.getters['candidate/getCandidateId'] || isTesting)
            return axios.get(urls.candidateAuth.candidateInfo.url, {
                params: {
                    accessToken: this.getAccessToken()
                }
            })
                .then(async response => {

                    await this.storeCandidate(response.data.data);
                    return response.data.data;

                }).catch(() => {
                    if (store.getters['candidate/getCandidatePin'])

                        this.candidateLogout(store.getters['candidate/getCandidatePin']);

                    else {
                        this.removeCandidateInfo();
                    }

                });
    },

    loadTestingCandidate() {
        this.setCandidateAxiosHeader();
        if (!store.getters['candidate/getCurrentTestingId'])
        {

            return axios.get(urls.candidateAuth.candidateInfo.url,{
                params:{
                    accessToken: this.getAccessToken()
                }
            })
                .then(async response => {
                    await this.storeCandidate(response.data.data);
                    return response.data.data;
                })
                .catch(() => {

                    this.snotifyError('errorAskAdmin', null, 5000);

                    if (store.getters['candidate/getCandidatePin'])
                        this.candidateLogout(store.getters['candidate/getCandidatePin']);
                    else
                        this.removeCandidateInfo();
                });
        }
    },

    candidateLogout(pin) {

        axios.post(urls.candidateAuth.logout.url, {pin: pin})
            .then(() => {

                if (localStorage.getItem('testingLocale') === 'ru_RU')
                    HelperFunctions.setDocumentTitle('Тестирование');
                else
                    HelperFunctions.setDocumentTitle('Сынак');

                this.removeCandidateInfo().then(() => {
                    this.setCandidateAxiosHeader();
                });
            }).catch(() => {
            this.snotifyError('errorAskAdmin', null, 5000);
        });
    },

    async removeCandidateInfo(redirect = true) {
        await store.dispatch('candidate/resetCandidate');
        await localStorage.removeItem('candidate_token');
        await localStorage.removeItem('access_token');

        if (redirect)
            router.replace({name: 'candidate.login'}).catch(() => {
            });

        return new Promise((resolve, reject) => {
            this.setCandidateAxiosHeader();
            resolve(true);
        });
    }


};
